import React from "react";
import ChargingMetricCurve from "./ChargingMetricCurve";
import ChargeMonitorConnectorInfo from "./ChargeMonitorConnectorInfo";
import ChargeMonitorActions from "./ChargeMonitorActions";
import { getStatusStripeStyle } from "../../helpers/StatusMapper";
import { SESSION_STATUSES } from "./chargeMonitorHelpers";

const ChargeMonitorConnectorCard = ({
    item,
    canManage,
    onAction,
    showDetailsToggle = true,
    detailsExpanded = false,
    renderedDetails = false,
    alwaysShowCurve = false,
}) => {
    const data = item?.Data || {};
    const status = (data.Status || data.chargingConnectorStatus || "").toUpperCase();
    const maintenanceMode = !!(data.maintenanceMode ?? data.MaintenanceMode);
    const visualStatus = maintenanceMode ? "UNAVAILABLE" : status;

    return (
        <div className="relative overflow-hidden bg-white border border-mute-200 rounded-xl shadow-md">
            <div
                className="absolute inset-y-0 left-0 w-1"
                style={getStatusStripeStyle(visualStatus)}
            />
            <div className="px-4 py-3">
                <div className="grid grid-cols-1 items-center gap-3 md:grid-cols-3 md:gap-5 xl:grid-cols-4">
                    <ChargeMonitorConnectorInfo item={item} />
                    <ChargeMonitorActions
                        item={item}
                        canManage={canManage}
                        onAction={onAction}
                        showDetailsToggle={showDetailsToggle}
                        detailsExpanded={detailsExpanded}
                    />
                </div>

                {alwaysShowCurve && SESSION_STATUSES.includes(status) ? (
                    <div className="pt-2">
                        <ChargingMetricCurve
                            isOpen
                            connectorPublicId={data.chargingConnectorPublicId}
                            useSse={true}
                        />
                    </div>
                ) : (
                    showDetailsToggle && SESSION_STATUSES.includes(status) && (
                        <div
                            className={`grid transition-[grid-template-rows,opacity] duration-[800ms] ease-in-out ${
                                detailsExpanded
                                    ? "grid-rows-[1fr] opacity-100"
                                    : "grid-rows-[0fr] opacity-0 pointer-events-none"
                            }`}
                        >
                            <div className="min-h-0 overflow-hidden">
                                {renderedDetails && (
                                    <div className="pt-2">
                                        <ChargingMetricCurve
                                            isOpen
                                            connectorPublicId={data.chargingConnectorPublicId}
                                            useSse={true}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default ChargeMonitorConnectorCard;
